import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import facebook from "../../assets/images/facebook-white.svg";
import instagram from "../../assets/images/instagram-white.svg";
import logoFooter from "../../assets/images/logo-footer.svg";
import "./style.scss";

const Footer = ({ language, changeLanguage }) => {
  const [searchParams] = useSearchParams();
  const langParams = searchParams.get("lang");
  const { t } = useTranslation();
  const [openTravel, setOpenTravel] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);

  return (
    <footer className="bg-twprimary text-white">
      <div className="border-b border-white">
        <div className="container flex justify-between items-center h-[62px] !px-4 lg:!px-0">
          <div className="flex !gap-5">
            <div>
              <a
                href="https://www.facebook.com/okayama.eng/"
                rel="noreferrer"
                target="_blank"
              >
                <img src={facebook} className="w-4 h-4" alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.instagram.com/?hl=ja"
                rel="noreferrer"
                target="_blank"
              >
                <img src={instagram} className="w-4 h-4" alt="" />
              </a>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined">language</span>

            <select
              onChange={(e) => changeLanguage(e.target.value)}
              value={langParams ? langParams : language}
              className="bg-transparent cursor-pointer"
            >
              <option value="en" className="bg-twprimary text-white">
                English
              </option>
              <option value="tw" className="bg-twprimary text-white">
                中文繁體
              </option>
              <option value="th" className="bg-twprimary text-white">
                ภาษาไทย
              </option>
              <option value="ko" className="bg-twprimary text-white">
                한국어
              </option>
              <option value="cn" className="bg-twprimary text-white">
                中文简体
              </option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <div className="container !px-4 lg:!px-0">
          <ul className="flex flex-col lg:flex-row lg:items-center lg:h-[85px] py-4 lg:py-0 gap-4 lg:gap-0">
            <li className="lg:h-[85px] w-full flex items-center">
              <div className="flex relative items-center justify-center flex-col">
                <a href={`https://www.okayama-japan.jp/${language}/abouts`}>
                  {t("about_okayama")}
                </a>
              </div>
            </li>
            <li className="lg:h-[85px] w-full flex items-center">
              <div className="flex relative items-center justify-center flex-col">
                <a href={`https://www.okayama-japan.jp/${language}/article`}>
                  {t("okatabi")}
                </a>
              </div>
            </li>
            <li className="lg:h-[85px] w-full flex items-center">
              <div className="flex relative items-center justify-center flex-col">
                <a href={`https://www.okayama-japan.jp/${language}/feature`}>
                  {t("specialties")}
                </a>
              </div>
            </li>
            <div className="relative lg:h-[85px] w-full flex flex-col justify-center">
              <li className="flex items-center relative">
                <div
                  className="flex relative items-center justify-center gap-2 lg:flex-col cursor-pointer"
                  onClick={() => setOpenTravel(!openTravel)}
                >
                  <div>{t("travel_genre")}</div>
                  <div className="arrow white !static lg:!absolute"></div>
                </div>
              </li>
              <div
                className={`${openTravel ? "block" : "hidden"} dropdown-footer`}
              >
                <ul>
                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/history`}
                    >
                      {t("history")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/nature`}>
                      {t("nature")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/townscape`}
                    >
                      {t("townscape")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/sakura`}>
                      {t("cherry")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/autumnleaves`}
                    >
                      {t("autumn")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/art`}>
                      {t("art")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/experience`}
                    >
                      {t("experience")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/gourment`}
                    >
                      {t("gourmet")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/spa`}>
                      {t("onsen")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/shopping`}
                    >
                      {t("shopping")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/souvenirs`}
                    >
                      {t("souvenirs")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/touristoffice`}
                    >
                      {t("tourist_info")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/recommended-course`}
                    >
                      {t("model_course")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/event`}>
                      {t("event")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <li className="lg:h-[85px] w-full flex items-center">
              <div className="flex relative items-center justify-center flex-col">
                <a href={`https://www.okayama-japan.jp/${language}/article`}>
                  {t("model_course")}
                </a>
              </div>
            </li>
            <div className="relative lg:h-[85px] w-full flex flex-col justify-center">
              <li className="flex items-center cursor-pointer">
                <div
                  className="flex relative items-center justify-center lg:flex-col gap-2"
                  onClick={() => setOpenInfo(!openInfo)}
                >
                  <div>{t("information")}</div>
                  <div className="arrow white !static lg:!absolute"></div>
                </div>
              </li>
              <div
                className={`${openInfo ? "block" : "hidden"} dropdown-footer`}
              >
                <ul>
                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/access`}>
                      {t("access")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/okayama-access-guide`}
                    >
                      {t("access_okayama")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/faq">{t("faq")}`}
                    />
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/interpreter`}
                    >
                      {t("national_govt")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/accept`}>
                      {t("okayama_prefect")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a href={`https://www.okayama-japan.jp/${language}/links`}>
                      {t("safety_info")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/timelapse`}
                    >
                      {t("time_lapse")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/guidemap`}
                    >
                      {t("brochure")}
                    </a>
                  </li>

                  <li className="dropdown-li">
                    <a
                      href={`https://www.okayama-japan.jp/${language}/privacy`}
                    >
                      {t("privacy_policy")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div className="bg-twsecondary ">
        <div className="container lg:h-[60px] flex flex-col lg:flex-row py-3 gap-2 items-center justify-between text-[12px] text-white ">
          <div className="text-center lg:text-start">
            Copyright © Okayama Prefectural Tourism Federation. All Right
            Reserved.
          </div>
          <div className="flex items-center gap-2">
            Powered by
            <div>
              <img className="h-4" src={logoFooter} alt="" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  language: PropTypes.string,
  changeLanguage: PropTypes.func,
};

export default Footer;
